/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownEligibilityType } from '../models/db_DropdownEligibilityType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EligibilityTypes {
    /**
     * Get a list of eligibility types
     * @returns db_DropdownEligibilityType OK
     * @throws ApiError
     */
    public static listEligibilityTypes(): CancelablePromise<Array<db_DropdownEligibilityType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/eligibility-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
